export class SitemapMessages {
  public accessibility = 'sitemap.accessibility';
  public commitmentQuality = 'sitemap.commitment-quality';
  public contact = 'sitemap.contact';
  public createSign = 'sitemap.create-sign';
  public home = 'sitemap.home';
  public knowUs = 'sitemap.know-us';
  public legalsNotices = 'sitemap.legals-notices';
  public ourEngagement = 'sitemap.our-engagements';
  public personalData = 'sitemap.personal-data';
  public sitemap = 'sitemap.sitemap';
  public verifySign = 'sitemap.verify-sign';

  constructor() {
  }
}
